<template>
  <div>
    <v-card class="mt-sm-8 mt-md-5 mt-7 bg-transparent">
      <div class="card-padding pb-0">
        <h3 class="text-h3 font-weight-bolder mb-2" style="color: #deaf72">
          鑅陞AI人資系統
        </h3>
        <p class="mb-0 text-body">輸入你的手機號碼與密碼</p>
      </div>
      <div class="card-padding pb-4">
        <label class="text-md text-typo font-weight-bolder ms-1">國碼</label>
        <v-select
          v-model="mobile_country_code"
          :items="countryCodes"
          hide-details
          outlined
          background-color="rgba(255,255,255,.9)"
          color="rgba(0,0,0,.6)"
          light
          height="40"
          class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
            country-code-select
          "
          style="max-width: 120px; min-width: 120px"
        >
        </v-select>
        <!-- <v-text-field
          hide-details
          outlined
          background-color="rgba(255,255,255,.9)"
          color="rgba(0,0,0,.6)"
          light
          height="40"
          placeholder="Email"
          class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
        >
        </v-text-field> -->
        <label class="text-md text-typo font-weight-bolder ms-1"
          >手機號碼</label
        >
        <v-text-field
          v-model="mobile_phone"
          hide-details
          outlined
          background-color="rgba(255,255,255,.9)"
          color="rgba(0,0,0,.6)"
          light
          height="40"
          placeholder="手機號碼"
          @keyup.enter="login"
          class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
        >
        </v-text-field>
        <label class="text-md text-typo font-weight-bolder ms-1">密碼</label>
        <v-text-field
          v-model="password"
          hide-details
          outlined
          background-color="rgba(255,255,255,.9)"
          color="rgba(0,0,0,.6)"
          light
          height="40"
          placeholder="密碼"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          @keyup.enter="login"
          class="
            input-style
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
        >
        </v-text-field>

        <v-checkbox
          v-model="rememberMe"
          color="#141727"
          :ripple="false"
          class="ma-0 checkbox-custom checkbox-thinner"
          hide-details
        >
          <template v-slot:label>
            <span class="text-typo text-body-2 ls-0">記住我</span>
          </template>
        </v-checkbox>

        <v-btn
          elevation="0"
          :ripple="false"
          height="43"
          class="
            font-weight-bold
            text-uppercase
            btn-primary
            bg-gradient-primary
            py-2
            px-6
            me-2
            mt-7
            mb-2
            w-100
          "
          color="#5e72e4"
          small
          @click="login"
          >登入</v-btn
        >
        <div class="text-center">
          <p class="text-sm text-body mt-3 mb-0">版本: {{ version }}</p>
        </div>
      </div>
    </v-card>

    <!-- InfoDialog for login errors -->
    <info-dialog
      :visible.sync="showInfoDialog"
      :title="infoDialogTitle"
      :message="infoDialogMessage"
      yes-button-text="確定"
    />

    <!-- Company selection dialog for multiple user accounts -->
    <v-dialog v-model="companyDialog.visible" max-width="480" persistent>
      <v-card class="card-shadow border-radius-xl">
        <v-card-title class="text-h5 text-typo">
          {{ companyDialog.title }}
        </v-card-title>
        <v-card-text>
          <p class="text-body-2 mb-4">
            {{ companyDialog.message }}
          </p>
          <v-list two-line dense>
            <v-list-item
              v-for="company in companyDialog.companies"
              :key="getCompanyId(company)"
              @click="retryLoginWithCompany(company)"
              :disabled="isRetryingCompany(company)"
              class="company-select-item"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ getCompanyDisplayName(company) }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="company.companyCode || company.code"
                >
                  {{ company.companyCode || company.code }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-progress-circular
                  v-if="isRetryingCompany(company)"
                  indeterminate
                  size="20"
                  width="2"
                  color="primary"
                />
                <v-icon v-else>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="closeCompanySelection"
            :disabled="retryingCompanyId !== null"
          >
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ProgressDialog for login loading -->
    <progress-dialog :visible="loading" message="登入中，請稍候..." />
  </div>
</template>

<script>
import InfoDialog from "@/components/Common/InfoDialog.vue";
import ProgressDialog from "@/components/Common/ProgressDialog.vue";
import pkg from "../../../../../package.json";

export default {
  name: "login",
  components: {
    InfoDialog,
    ProgressDialog,
  },
  data() {
    return {
      mobile_country_code: "+886",
      mobile_phone: "",
      password: "",
      showPassword: false,
      rememberMe: true,
      loading: false,
      errorMessage: "",
      countryCodes: ["+886"], // Currently only one option as specified
      showInfoDialog: false,
      infoDialogTitle: "",
      infoDialogMessage: "",
      version: pkg.version,
      companyDialog: {
        visible: false,
        title: "請選擇公司",
        message: "",
        companies: [],
      },
      pendingLoginPayload: null,
      retryingCompanyId: null,
    };
  },
  mounted() {
    // Load remembered mobile_phone
    this.mobile_phone = this.$store.getters["user/userMobilePhone"];
  },
  methods: {
    async login() {
      this.loading = true;
      this.errorMessage = "";

      if (
        !this.mobile_country_code.trim() ||
        !this.mobile_phone.trim() ||
        !this.password.trim()
      ) {
        this.errorMessage = "請填寫所有必填欄位";
        this.loading = false;
        alert(this.errorMessage);
        return;
      }

      const loginData = this.buildLoginPayload();
      this.pendingLoginPayload = loginData;

      try {
        const response = await this.performLoginRequest(loginData);
        this.handleLoginSuccess(response.data.user, response.data.tokens);
      } catch (error) {
        this.handleLoginError(error);
      } finally {
        this.loading = false;
      }
    },

    buildLoginPayload(extra = {}) {
      return {
        mobile_country_code: this.mobile_country_code,
        mobile_phone: this.mobile_phone,
        password: this.password,
        ...extra,
      };
    },

    async performLoginRequest(payload) {
      return this.$axios.post("/api/auth/login", payload);
    },

    handleLoginSuccess(user, tokens) {
      this.$store.dispatch("user/login", {
        id: user.id,
        name: user.name,
        token: tokens.accessToken,
        company_id: user.company_id,
        role: user.role,
        enable_salary_preview: !!user.enable_salary_preview,
      });

      if (this.rememberMe) {
        this.$store.dispatch("user/setMobilePhone", this.mobile_phone);
      }

      this.pendingLoginPayload = null;
      this.closeCompanySelection();

      if (user.role === "employee") {
        this.$router.push("/pages/users/profile");
      } else {
        this.$router.push("/pages/dashboards/clock-records");
      }
    },

    handleLoginError(error) {
      console.error("Login error:", error);

      const status = error.response?.status;
      const errorCode = error.response?.data?.error;
      const message = error.response?.data?.message;
      const companies = error.response?.data?.companies || [];

      if (
        status === 409 &&
        this.isMultipleUsersError(errorCode) &&
        Array.isArray(companies) &&
        companies.length > 0
      ) {
        this.openCompanySelection(
          companies,
          message || "找到多個使用者帳號，請選擇公司"
        );
        return;
      }

      if (status === 401 && errorCode === "login_failed") {
        this.infoDialogTitle = "登入失敗";
        this.infoDialogMessage = "帳號或密碼錯誤，請重新輸入";
      } else {
        this.errorMessage = message || "登入失敗，請重新輸入";
        this.infoDialogTitle = "登入失敗";
        this.infoDialogMessage = this.errorMessage;
      }
      this.showInfoDialog = true;
    },

    isMultipleUsersError(errorCode) {
      if (!errorCode) return false;
      const normalizedCode = String(errorCode).toLowerCase();
      return normalizedCode === "multiple_users_found";
    },

    openCompanySelection(companies, message) {
      this.companyDialog = {
        visible: true,
        title: "請選擇公司",
        message,
        companies,
      };
    },

    closeCompanySelection() {
      this.companyDialog = {
        visible: false,
        title: "請選擇公司",
        message: "",
        companies: [],
      };
    },

    getCompanyDisplayName(company) {
      return (
        company?.companyName ||
        company?.company_name ||
        company?.name ||
        "未命名公司"
      );
    },

    getCompanyId(company) {
      return company?.companyId || company?.company_id || company?.id || null;
    },

    isRetryingCompany(company) {
      const companyId = this.getCompanyId(company);
      return companyId !== null && companyId === this.retryingCompanyId;
    },

    async retryLoginWithCompany(company) {
      if (this.retryingCompanyId !== null) {
        return;
      }

      const companyId = this.getCompanyId(company);
      if (!companyId) {
        this.infoDialogTitle = "登入失敗";
        this.infoDialogMessage = "無法取得公司資料，請稍後再試";
        this.showInfoDialog = true;
        return;
      }

      const basePayload = this.pendingLoginPayload || this.buildLoginPayload();
      const retryPayload = {
        ...basePayload,
        company_id: companyId,
        companyId,
      };

      this.retryingCompanyId = companyId;
      this.loading = true;

      try {
        const response = await this.performLoginRequest(retryPayload);
        this.handleLoginSuccess(response.data.user, response.data.tokens);
      } catch (error) {
        this.handleLoginError(error);
      } finally {
        this.loading = false;
        this.retryingCompanyId = null;
      }
    },
  },
};
</script>
<style scoped>
.country-code-select {
  flex-grow: 0;
}
.company-select-item {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin-bottom: 8px;
}
</style>
